export type AdminEnvironment = "local" | "stage" | "prod";
export type AdminCapability = "admin:read" | "admin:campaigns"
  | "admin:mining" | "admin:support" | "admin:workers" | "admin:devnet-grants";

export type AdminConfig = Readonly<{
  environment: AdminEnvironment;
  apiBaseUrl: string;
  authMode: "cognito" | "dev";
  authDomain: string;
  clientId: string;
  userPoolId: string;
  region: string;
  redirectUri: string;
  logoutUri: string;
  capabilities: readonly AdminCapability[];
  buildSha: string;
}>;

export type AdminIdentity = Readonly<{
  subject: string;
  email: string | null;
  groups: readonly string[];
  capabilities: readonly AdminCapability[];
  role: "viewer" | "operator";
}>;

export type AdminEnvelope<T = Record<string, unknown>> = Readonly<{
  environment: AdminEnvironment;
  asOf: string;
  sourceAvailability: Readonly<Record<string, "AVAILABLE" | "UNAVAILABLE" | "STALE">>;
  data: T;
}>;

export type TokenSet = Readonly<{
  accessToken: string;
  idToken: string;
  refreshToken?: string;
  expiresAtMs: number;
  refreshExpiresAtMs?: number;
}>;

declare global {
  interface Window { MEGACORP_ADMIN_CONFIG?: AdminConfig }
}
declare const __ADMIN_LOCAL_AUTH_COMPILED__: boolean;

const rawConfig = window.MEGACORP_ADMIN_CONFIG;
if (!rawConfig) throw new Error("admin_config_missing");
export const config: AdminConfig = rawConfig;
if (config.authMode === "dev" && (!__ADMIN_LOCAL_AUTH_COMPILED__ || config.environment !== "local")) {
  throw new Error("admin_dev_auth_forbidden");
}
